// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5eb1a1e8","239":"da3df550","827":"57d9ce5c"}[chunkId] + ".chunk.js";
};